import { autoUpdate, flip, offset, shift } from '@floating-ui/react-dom';
import {
  useClick,
  useDismiss,
  useFloating,
  useInteractions,
} from '@floating-ui/react-dom-interactions';
import { useCallback, useState } from 'preact/hooks';

export function useActionList() {
  const [open, setOpen] = useState(false);
  const { x, y, reference, floating, strategy, context } = useFloating({
    open,
    whileElementsMounted: autoUpdate,
    onOpenChange: setOpen,
    middleware: [flip(), shift({}), offset(10)],
  });
  const { getFloatingProps, getReferenceProps } = useInteractions([
    useClick(context),
    useDismiss(context, {
      outsidePress: true,
    }),
  ]);
  const close = useCallback(() => setOpen(false), []);

  return {
    open,
    close,
    reference,
    floating,
    floatingStyle: {
      position: strategy,
      left: x ?? 0,
      top: y ?? 0,
    },
    floatingProps: getFloatingProps(),
    referenceProps: getReferenceProps(),
  };
}
